import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSetAtom } from 'jotai';
import { Group, Rect, Text } from 'react-konva';
import { selectedIdsAtom } from '@/store/boardAtoms';
/**
 * Лейбл для презентационного фрейма, отображаемый над левым верхним углом элемента
 *
 * @param props - Пропсы компонента
 */
export const PresentationFrameLabel = ({ x, y, offsetX, offsetY, rotation, label, elementId, visible = true, }) => {
    const setSelectedIds = useSetAtom(selectedIdsAtom);
    const padding = 4;
    const fontSize = 12;
    const lineHeight = fontSize;
    const backgroundColor = '#142F44E1';
    const textColor = '#62B2F8';
    const borderColor = '#62B2F8';
    if (!visible) {
        return null;
    }
    // Используем центр и offset кадра; отступ плашки поворачивается вместе с ним.
    const labelOffsetY = offsetY + lineHeight + padding * 2 + 2;
    // Вычисляем ширину текста (приблизительно, с учетом разных символов)
    // Используем более точную оценку: средняя ширина символа для Arial ~0.6 от размера шрифта
    const textWidth = Math.max(label.length * fontSize * 0.6, 60); // Минимальная ширина для коротких названий
    const handleClick = (e) => {
        e.cancelBubble = true; // Предотвращаем всплытие события
        setSelectedIds((prev) => {
            if (e.evt.shiftKey) {
                if (prev.includes(elementId)) {
                    return prev.filter((id) => id !== elementId);
                }
                return [...prev, elementId];
            }
            return [elementId];
        });
    };
    return (_jsxs(Group, { x: x, y: y, offsetX: offsetX, offsetY: labelOffsetY, rotation: rotation, listening: true, onClick: handleClick, onTap: handleClick, onMouseEnter: (e) => {
            const stage = e.target.getStage();
            if (stage) {
                stage.container().style.cursor = 'pointer';
            }
        }, onMouseLeave: (e) => {
            const stage = e.target.getStage();
            if (stage) {
                stage.container().style.cursor = 'default';
            }
        }, children: [_jsx(Rect, { x: 0, y: 0, width: textWidth + padding * 2, height: lineHeight + padding * 2, fill: backgroundColor, stroke: borderColor, strokeWidth: 0.5, cornerRadius: 4, strokeScaleEnabled: true }), _jsx(Text, { padding: padding, text: label, fontSize: fontSize, fontFamily: "Arial, sans-serif", fill: textColor, align: "center" })] }));
};
